"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseTimeBlocks = exports.getPreviousPageHTML = exports.formatDate = exports.toDateStr = exports.getScrollablePage = exports.useIsomorphicLayoutEffect = exports.flagMountAnimated = exports.alreadyMountAnimated = exports.isSameCheckedValue = exports.isUsingSafari = exports.isIOSDevice = exports.isUsingAppWebview = exports.hasNotch = exports.createSyntheticChangeEvent = exports.isOnMobileDevice = exports.getJourneyColors = exports.getBreakpoint = exports.isSmallScreen = exports.newArray = exports.resolveCssProp = exports.getSwipeDirection = exports.getSwipePower = exports.isFocused = exports.createSimulatedEvent = exports.isPromise = exports.findChildComponent = exports.hasChildComponent = exports.removeOrAdd = exports.isEmpty = exports.isServer = exports.isClient = exports.snakeCaseToWords = exports.mergeRefs = exports.getCookie = exports.getCookiesFromResponse = exports.usePrimitiveProps = exports.getValidPrimitiveProps = exports.without = exports.withoutQueryParams = exports.optionalModule = void 0;
const react_1 = __importStar(require("react"));
const capitalize_1 = __importDefault(require("capitalize"));
const date_fns_1 = require("date-fns");
const isValidProp_1 = __importDefault(require("./isValidProp"));
const mergeProps_1 = __importDefault(require("./mergeProps"));
function optionalModule(callback) {
    try {
        return callback();
    }
    catch (_a) {
        // do nothing
    }
    return null;
}
exports.optionalModule = optionalModule;
function withoutQueryParams(url) {
    return url.split('?')[0];
}
exports.withoutQueryParams = withoutQueryParams;
// Remove values from an object by keys
function without(props, propNames = []) {
    return Object.keys(props)
        .reduce((carry, key) => {
        if (!propNames.includes(key)) {
            carry[key] = props[key];
        }
        return carry;
    }, {});
}
exports.without = without;
// Protects us from accidentally dumping invalid react props into a component.
function getValidPrimitiveProps(props, isValidPropResolver = isValidProp_1.default) {
    return Object.keys(props).reduce((carry, propName) => {
        if (isValidPropResolver(propName) && props[propName] !== undefined) {
            carry[propName] = props[propName];
        }
        return carry;
    }, {});
}
exports.getValidPrimitiveProps = getValidPrimitiveProps;
/*
* This allows a safe transfer at any point of a component prop pass through to a functional component.
* Functional components can not have "ref" props and our HOC (withJourney) will properly handle the refs
* for us by specifying a "forwardedRefs" prop.
*/
// export function fillFunctionalProps(props, additionalClassNames = {}, extraRefs: any[] = []) {
//   return {
//     ...props,
//     ref: undefined,
//     href: props.href,
//     className: dedupe(classNames(props.className, additionalClassNames)),
//     forwardedRefs: [...(props.forwardedRefs || []), ...extraRefs] as any,
//   }
// }
function dedupeClassNames(className) {
    if (!className) {
        return className;
    }
    const classes = className.split(' ');
    return classes.filter((s, i) => classes.indexOf(s) === i).join(' ');
}
/*

/*
* This allows a safe transfer at any point of a component prop pass through to a primitive component such as
* a div,span,ui,li etc. Primitive components are very picky about what props they get sent
* and will warn us about a prop being passed down even if it doesnt use it.
*/
function usePrimitiveProps(...props) {
    const newProps = mergeProps_1.default(...props);
    const className = dedupeClassNames(newProps.className);
    // combine any previously forwardedRefs and extraRefs
    // const forwardedRefs = (newProps.forwardedRefs || []).concat(extraRefs)
    const primitiveProps = Object.assign(Object.assign({}, getValidPrimitiveProps(newProps)), { ref: newProps.forwardedRef, className });
    delete primitiveProps.forwardedRef;
    delete primitiveProps.href;
    delete primitiveProps.testId;
    return primitiveProps;
}
exports.usePrimitiveProps = usePrimitiveProps;
function getCookiesFromResponse(response) {
    const raw = response.headers.raw()['set-cookie'];
    const cookieStrs = raw.map((entry) => {
        const parts = entry.split(';');
        const cookiePart = parts[0];
        return cookiePart;
    });
    const cookie = {};
    cookieStrs.forEach((cookieStr) => {
        const equalSides = cookieStr.split('=');
        const name = equalSides[0];
        const value = equalSides[1];
        cookie[name] = value;
    });
    return cookie;
}
exports.getCookiesFromResponse = getCookiesFromResponse;
function getCookie(res, cname) {
    if (isServer()) {
        return getCookiesFromResponse(res)[cname];
    }
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    // eslint-disable-next-line no-plusplus,no-restricted-syntax
    for (let c of ca) {
        while (c.charAt(0) === ' ') {
            c = c.slice(1);
        }
        if (c.indexOf(name) === 0) {
            return c.slice(name.length, c.length);
        }
    }
    return '';
}
exports.getCookie = getCookie;
function mergeRefs(refs) {
    return (returnedRef) => {
        refs.filter((ref) => !!ref)
            .forEach((ref) => {
            try {
                ref instanceof Function ? ref(returnedRef) : ref.current = returnedRef;
            }
            catch (error) {
                console.error(error, ref);
                // some refs are not "extensible" do nothing.
            }
        });
    };
}
exports.mergeRefs = mergeRefs;
// Turn "a_property_name" to "A property toppingName"
function snakeCaseToWords(str) {
    return capitalize_1.default(str.replace(new RegExp('_', 'g'), ' '));
}
exports.snakeCaseToWords = snakeCaseToWords;
function isClient() {
    return !isServer();
}
exports.isClient = isClient;
function isServer() {
    return typeof window === 'undefined' || process.env.JEST_WORKER_ID !== undefined;
}
exports.isServer = isServer;
function isEmpty(val) {
    if (Array.isArray(val))
        return val.length === 0;
    return val === '' || val === null || val === undefined;
}
exports.isEmpty = isEmpty;
function removeOrAdd(array, row, selector = (a, b) => a.hashid === b.hashid) {
    const alreadyExists = array.filter((_item) => selector(_item, row)).length > 0;
    if (alreadyExists) {
        return array.filter((_item) => !selector(_item, row));
    }
    return [...array, row];
}
exports.removeOrAdd = removeOrAdd;
// Go through the props of a component and see if we can find a child component
function hasChildComponent(props, className) {
    return !!findChildComponent(props, className);
}
exports.hasChildComponent = hasChildComponent;
// that contains a certain classname.
function findChildComponent(props, className, component) {
    if (!props) {
        return;
    }
    const { children, type } = props;
    if ((type === null || type === void 0 ? void 0 : type.displayName) === className) {
        return {
            node: children,
            siblings: undefined,
        };
    }
    if (!children || typeof children === 'string') {
        return;
    }
    if (component) {
        // React.children.map changes the node type??
        const foundViaComponent = (Array.isArray(children) ? children : [children]).find((child) => child.type === component);
        if (foundViaComponent) {
            return foundViaComponent;
        }
    }
    return react_1.default.Children.map(children, (node) => {
        var _a, _b, _c, _d, _e;
        if (!node) {
            return null;
        }
        let matches = false;
        if (((_a = node.type) === null || _a === void 0 ? void 0 : _a.displayName) === className || (component && node.type === component)) {
            matches = true;
        }
        if ((_c = (_b = node.props) === null || _b === void 0 ? void 0 : _b.className) === null || _c === void 0 ? void 0 : _c.split(' ').includes(className)) {
            matches = true;
        }
        if (!matches && ((_d = node.props) === null || _d === void 0 ? void 0 : _d.children)) {
            return findChildComponent({ children: (_e = node.props) === null || _e === void 0 ? void 0 : _e.children }, className);
        }
        if (matches) {
            return {
                siblings: children,
                node,
            };
        }
    }).find((n) => !!n);
}
exports.findChildComponent = findChildComponent;
// https://github.com/graphql/graphql-js/blob/main/src/jsutils/isPromise.js
function isPromise(value) {
    return Boolean(value && typeof value.then === 'function');
}
exports.isPromise = isPromise;
/** To keep onChange consistently always returning a event with a "event.target.value"
 * this generates a event for packages that only provide the new value.
 * @param node
 * @param value MUST BE A STRING.
 */
function createSimulatedEvent(node, value) {
    const inputEvent = (new Event('input', { bubbles: true }));
    const prototypeValue = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
    if (!node) {
        console.error('No node provided to create simulated event.');
        return;
    }
    if ((node === null || node === void 0 ? void 0 : node.value) === value) {
        console.error(node, `Cant create a simulated event because its value is already "${value}".`);
    }
    if (prototypeValue === null || prototypeValue === void 0 ? void 0 : prototypeValue.set) {
        prototypeValue.set.call(node, value);
    }
    node === null || node === void 0 ? void 0 : node.dispatchEvent(inputEvent);
}
exports.createSimulatedEvent = createSimulatedEvent;
function isFocused(ref) {
    const ele = ref.current;
    if (!ele) {
        return false;
    }
    try {
        const ele = ref === null || ref === void 0 ? void 0 : ref.current;
        return [ele, ele === null || ele === void 0 ? void 0 : ele.querySelector('input')].includes(document === null || document === void 0 ? void 0 : document.activeElement);
    }
    catch (_a) {
        // do nothing
    }
    return false;
}
exports.isFocused = isFocused;
/**
 * Experimenting with distilling swipe offset and velocity into a single variable, so the
 * less distance a user has swiped, the more velocity they need to register as a swipe.
 * Should accommodate longer swipes and short flicks without having binary checks on
 * just distance thresholds and velocity > 0.
 */
const getSwipePower = (offset, velocity) => Math.abs(offset) * velocity;
exports.getSwipePower = getSwipePower;
const getSwipeDirection = (power, threshold = 10000) => {
    if (power < -threshold) {
        return 'left';
    }
    if (power > threshold) {
        return 'right';
    }
    // no swipe, nothing was powerful enough.
};
exports.getSwipeDirection = getSwipeDirection;
function resolveCssProp(cssClassName, data) {
    if (!data) {
        return {};
    }
    if (typeof data === 'number') {
        return {
            [`${cssClassName}-${data}`]: true,
        };
    }
    const cssClasses = {};
    Object.keys(data).forEach((key) => {
        cssClasses[`${cssClassName}-${key}-${data[key]}`] = true;
    });
    return cssClasses;
}
exports.resolveCssProp = resolveCssProp;
function newArray(length) {
    return [...new Array(length).keys()];
}
exports.newArray = newArray;
function isSmallScreen() {
    return getBreakpoint() === 'xs';
}
exports.isSmallScreen = isSmallScreen;
function getBreakpoint() {
    if (isServer()) {
        return 'xl';
    }
    const clientWidth = window.innerWidth;
    const breakpoints = {
        xl: clientWidth >= 1280,
        lg: clientWidth >= 1024,
        md: clientWidth >= 768,
        sm: clientWidth >= 480,
        xs: clientWidth < 480,
    };
    return Object.keys(breakpoints).find((sizeName) => !!breakpoints[sizeName]);
}
exports.getBreakpoint = getBreakpoint;
const resolveColor = (varName) => `rgba(var(--${varName}), 1)`;
function getJourneyColors() {
    return {
        primary: resolveColor('primary'),
        secondary: resolveColor('secondary'),
        footer: resolveColor('footer'),
        // primaryContrastColor: resolveColor('primary-contrast'),
        body: resolveColor('body'),
        panel: resolveColor('panel'),
        bodyHover: resolveColor('body-hover'),
        typography: resolveColor('typography'),
        inputBackground: resolveColor('input-background'),
        scrollbarBackground: resolveColor('scrollbar-background'),
    };
}
exports.getJourneyColors = getJourneyColors;
/* This can be an android phone on chrome or iOS phone on safari, doesnt mean they are on the mobile app. */
function isOnMobileDevice() {
    if (isServer()) {
        return false;
    }
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent);
}
exports.isOnMobileDevice = isOnMobileDevice;
const createSyntheticChangeEvent = (inputEle, value) => {
    const e = new Event('change');
    Object.defineProperty(e, 'target', { writable: false, value: inputEle });
    if (inputEle) {
        Object.defineProperty(inputEle, 'value', { writable: false, value });
    }
    return e;
};
exports.createSyntheticChangeEvent = createSyntheticChangeEvent;
function hasNotch() {
    if (isServer() || !isUsingAppWebview()) {
        return false;
    }
    return getComputedStyle(document.documentElement).getPropertyValue('env(safe-area-inset-top)') !== '';
}
exports.hasNotch = hasNotch;
// eslint-disable-next-line max-len
/*
  Android:
   Mozilla/5.0 (Linux; Android 10; Android SDK built for x86 Build/QSR1.200715.002; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/74.0.3729.185 Mobile Safari/537.36

   Linux Brave:
   Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.114 Safari/537.36

   iPhone Safari:
   Mozilla/5.0 (iPhone; CPU iPhone OS 14_6 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.1 Mobile/15E148 Safari/604.1

   iPhone WebView:
   Mozilla/5.0 (iPhone; CPU iPhone OS 14_5 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148
* */
function isUsingAppWebview() {
    if (isServer() || isUsingSafari()) {
        return false;
    }
    return isIOSDevice() || navigator.userAgent.includes('wv)');
}
exports.isUsingAppWebview = isUsingAppWebview;
function isIOSDevice() {
    if (isServer()) {
        return false;
    }
    return /iphone|ipad|ipod/i.test(navigator.userAgent);
}
exports.isIOSDevice = isIOSDevice;
function isUsingSafari() {
    if (isServer()) {
        return false;
    }
    return /(iphone|ipod|ipad).*applewebkit.*safari/i.test(navigator.userAgent);
}
exports.isUsingSafari = isUsingSafari;
function isSameCheckedValue(value, checkedValue) {
    if (Array.isArray(value) && !Array.isArray(checkedValue)) {
        return value.includes(checkedValue);
    }
    if (checkedValue === true) {
        return value === 1 || value === true;
    }
    if (checkedValue === false) {
        return value === 0 || value === false;
    }
    return value === checkedValue;
}
exports.isSameCheckedValue = isSameCheckedValue;
const mountAnimations = {};
function alreadyMountAnimated(key) {
    return mountAnimations[key];
}
exports.alreadyMountAnimated = alreadyMountAnimated;
function flagMountAnimated(key) {
    mountAnimations[key] = true;
}
exports.flagMountAnimated = flagMountAnimated;
exports.useIsomorphicLayoutEffect = isServer() ? react_1.useEffect : react_1.useLayoutEffect;
function getScrollablePage() {
    const pages = [...document.querySelectorAll('.j-page')];
    return pages.find((p) => !p.className.includes('previous-page'));
}
exports.getScrollablePage = getScrollablePage;
function toDateStr(value) {
    const date = new Date(value);
    // eslint-disable-next-line unicorn/consistent-function-scoping
    function ten(amt) {
        return amt < 10 ? `0${amt}` : `${amt}`;
    }
    /// yyyy-mm-dd
    return `${date.getUTCFullYear()}-${ten(date.getUTCMonth() + 1)}-${ten(date.getUTCDate())}`;
}
exports.toDateStr = toDateStr;
function formatDate(value, formatStr) {
    try {
        return date_fns_1.format(new Date(value), formatStr);
    }
    catch (_a) {
        console.error(`<DateFormat> Failed to format date with props: {value: "${value}", format: "${formatStr}"}`);
    }
}
exports.formatDate = formatDate;
const getPreviousPageHTML = (ele) => {
    const clonedNode = ele === null || ele === void 0 ? void 0 : ele.cloneNode(true);
    if (clonedNode) {
        // remove any ids to prevent bad selecting
        clonedNode.querySelectorAll('[id]')
            .forEach((ele) => ele.removeAttribute('id'));
        // remove any scripts, not needed
        clonedNode.querySelectorAll('script')
            .forEach((script) => script.remove());
        // remove any page loader
        clonedNode.querySelectorAll('#nprogress').forEach((bar) => bar.remove());
        return clonedNode.innerHTML;
    }
};
exports.getPreviousPageHTML = getPreviousPageHTML;
function parseTimeBlocks(msg) {
    var _a;
    if (!msg) {
        return '';
    }
    /* This allows us to send in something like [TIME=2021-08-17T14:00:00Z] and have it convert into their local time. */
    const timeBlocks = (_a = msg.match(/\[TIME=(.*?)]/g)) !== null && _a !== void 0 ? _a : [];
    let newErrorMsg = msg;
    timeBlocks.forEach((timeBlock) => {
        /* The actual datetime string, [TIME=*] */
        let value = timeBlock.split('[TIME=')[1].replace(']', '');
        let formatStr = 'h:mma';
        const containsFormat = value.includes(',');
        if (containsFormat) {
            const parts = value.split(',');
            // eslint-disable-next-line prefer-destructuring
            formatStr = parts[1];
            // eslint-disable-next-line prefer-destructuring
            value = parts[0];
        }
        /* Replace in the original string "[TIME=2021-08-17T14:00:00Z]" to "7:00AM" */
        newErrorMsg = newErrorMsg.replace(timeBlock, date_fns_1.format(new Date(value), formatStr));
    });
    return newErrorMsg;
}
exports.parseTimeBlocks = parseTimeBlocks;
